import { CSShiftType } from '@/api/apis/resources/schedule';

export enum CSShiftOptionType {
  OnCall = CSShiftType.OnCall,
  ExtraCall = 'ExtraCall',
  OfficeDay = CSShiftType.OfficeDay,
  AtHub = CSShiftType.AtHub,
  PhoneSupport = CSShiftType.PhoneSupport,
  NoCall = CSShiftType.NoCall,
  BlockedNoCall = 'BlockedNoCall',
  WeekendOff = CSShiftType.WeekendOff,
  TravelDay = CSShiftType.TravelDay,
  FloatingHoliday = 'FloatingHoliday',
  Sick = CSShiftType.Sick,
  Vacation = CSShiftType.Vacation,
  Unavailable = CSShiftType.Unavailable,
}

export type CSShiftEdgeColors = {
  /** Published identity colour — published overlap gradient/stripes, pre-schedule/planning stripes and the published gap border. */
  color: string;
  /** Light-tinted cell background, opaque over the white row — solid base of pre-schedule/planning overlaps. */
  bg: string;
  /** Cell border colour — pre-schedule/planning overlap (top/bottom) and gap borders. */
  border: string;
};
